import React, { useState, useEffect } from 'react';
import gt_seal from '../../static/georgia_tech_seal.png';
import ray_grad from '../../static/ray_grad.JPG';

function Undergrad() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWidth(window.innerWidth);
    });
  }, []);

  return (
    <div className='card-right'>
      <div className='card-content-left'>
        <img className='card-image' src={ray_grad}/>
      </div>
      <div className='card-content-right'>
        <div className='card-title-box'>
          <div className='card-title-logo'>
            <img className="card-logo" src={gt_seal}/>
          </div>
          <div className='card-title'>
            {/* <h5>Education</h5> */}
            {
              width < 707
              ? <h2>Georgia Tech</h2>
              : <h2>Georgia Institute of Technology</h2>
            }
            <h5>Atlanta, GA</h5>
          </div>
        </div>
        <div className='card-details-box'>
          <h4>B.S. Computer Engineering</h4>
          <h5>Aug 2019 - May 2022</h5>
        </div>
        <div className='card-content'>
          <div className='child-div'>
            <p>
              I spent my undergrad trying to figure out where my interests lay, dabbling in IoT, Embedded Systems, Robotics, and Cybersecurity before eventually realizing I was more interested in Software Development and Machine Learning.
            </p>
          </div>
          <div className='child-div'>
            <p>
              Outside of coursework, I also participated in project and research team opportunities provided by Georgia Tech.
              <ul style={{marginLeft: "1.5rem"}}>
                <li><a href='https://www.vip.gatech.edu/teams/vp3' target='_blank'>(2020) Stadium Internet of People and Things (IoPT)</a></li>
                <li><a href='https://athena.gatech.edu' target='_blank'>(2021) ATHENA Lab Research Assistant</a> - Low power wearable medical technologies</li>
                <li><a href='https://ivalab.gatech.edu' target='_blank'>(2022) IVA Lab Research Assistant</a> - Automous Robotics</li>
              </ul>
            </p>
          </div>
          <div className='child-div'>
            <h5>Notable Coursework</h5>
            <ul style={{marginLeft: "1.5rem"}}>
              <li><a href='https://alregib.ece.gatech.edu/ece4803-funml/' target='_blank'>Fundamentals of Machine Learning</a> - Prof. Al-Regib</li>
              <li><a href='https://mdav.ece.gatech.edu/ece-3803-fall2021/' target='_blank'>Optimization for Information Systems</a> - Prof. Davenport</li>
              <li><a href='https://ece.gatech.edu/courses/ece4122' target='_blank'>Advanced Programming Techniques</a> - Prof. Hurley</li>
              <li><a href='https://saltaformaggio.ece.gatech.edu/teaching/spring2021/intro-re/' target='_blank'>Intro to Malware Reverse Engineering</a> - Prof. Saltaformaggio</li>
            </ul>
          </div>
          <div className='child-div'>
            <h5>Interesting Projects</h5>
            <ul style={{marginLeft: "1.5rem"}}>
              <li><a href='https://eceseniordesign2022spring.ece.gatech.edu/sd22p06/' target='_blank'>TranzVolt 2.0</a></li>
              <li><a href='https://youtu.be/6Io7z_UpGrE' target='_blank'>SQL/Flask Vacation Booking System</a></li>
              <li><a href='https://youtu.be/MKxbEseK9wA' target='_blank'>Multithreading Projects</a></li>
              <li><a href='https://youtu.be/rRpDxnoCtgs' target='_blank'>Embedded MBed Projects</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Undergrad;